// A job's setup is its admin's or job manager's to change. The API keeps the setup in a save from
// anybody else as it was (ReviewTimeJobSave), so Job setup's Save says so before the click instead of
// taking edits that would come back unchanged, and a proposal that is ready is not taken into use on its
// own for them (the automatic start saves the job as set up, which only a manager's save does).

/** The hover text on Job setup's Save for a person who does not run jobs. */
export const SETUP_ROLE_HINT = 'An admin or a job manager changes job setup';

/** Whether the person may change a job's setup (the bridge's `runsJobs`; a host that does not say, may). */
export function changesSetup(): boolean {
  return window.paigeWorkbench?.runsJobs !== false;
}
